import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';

import { accordionSchemaData } from "./accordionSchemaData";
import { accordionFaqData } from "./accordionFaqData";

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  "&::before": {
    display: "none",
  },
});

const StyledSummary = styled(AccordionSummary)({
  cursor: "pointer",
  padding: "15px 0",
  width: "100%",
  border: "none",
  textAlign: "left",
  outline: "none",
  fontSize: "15px",
  transition: "0.4s",
  background: 'transparent',
  borderBottom: '1px solid #fff',
  fontWeight: "400",
  position: "relative",
  "&:after": {
    content: "''",
    position: "absolute",
    backgroundImage: "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/icon-plus-1.svg)",
    top: "calc(50% - 20px)",
    right: 0,
    width: "40px",
    height: "40px",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "@media (max-width: 600px)": {
      top: "calc(50% - 15px)",
      width: "30px",
      height: "30px",
    },
  },
  "&.Mui-expanded": {
    borderBottom: "1px solid transparent",
    "&:after": {
      backgroundImage: "url(https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat/icon-close-1.svg)",
    }
  },
  ".MuiAccordionSummary-content": {
    margin: 0,
    paddingRight: "70px",
    display: "flex",
    flexDirection: "column",
    //borderBottom: '1px solid #fff',
    "@media (max-width: 600px)": {
      paddingRight: "35px",
    }
  },
});

const StyledDetails = styled(AccordionDetails)({
  backgroundColor: 'transparent',
  overflow: "hidden",
  fontWeight: 400,
  fontSize: "18px",
  lineHeight: "120%",
  "@media (max-width: 767px)": {
    fontSize: "16px",
  },
  "p": {
    marginBottom: "20px",
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  "ul": {
    paddingLeft: "20px",
  },
  "ul li": {
    listStyle: "disc",
  },
})

export const StructureBlocksOld = ({ ttlClassName, blockType }) => { // blockType === schema or faq

  return (
    <div>
      {(blockType === "schema" ? accordionSchemaData : accordionFaqData).map((elem, index) => (
        <StyledAccordion disableGutters={true} key={index} square defaultExpanded={index === 0}>
          <StyledSummary>
            <div className={ttlClassName}>
              {elem.title}
            </div>
          </StyledSummary>
          <StyledDetails>
            {elem.description}
          </StyledDetails>
        </StyledAccordion>
      ))}
    </div>
  );
};
